import React, { useEffect, useRef, useState } from "react";

import API from "../../api";


interface _FunctionWrapper {
  func:Function
}

export default class OnAfterModalClosed {

  private afterModalClosedFunc_:_FunctionWrapper;
  private setAfterModalClosedFunc_:any;
  constructor (props:any) {
    [this.afterModalClosedFunc_, this.setAfterModalClosedFunc_] = useState({func:null});

    // for callback after modal closed
    useEffect(() => {
      if (this.afterModalClosedFunc_.func === null)
        return;

      const isClosed = !!(props.modal && !props.modal.closeModal && props.modal.isVisible === false);
      if (isClosed === false)
        return;

      this.afterModalClosedFunc_.func();
      this.setAfterModalClosedFunc_({func:null});
    });
  }

  set (func:Function):any {
    this.setAfterModalClosedFunc_({func:func});
  }

};
